export const TYPES = {
  OPEN_NAV_SEARCH: "OPEN_NAV_SEARCH",
  CLOSE_NAV_SEARCH: "CLOSE_NAV_SEARCH",
};

export function openNavSearch() {
  return async (dispatch) => {
    dispatch({ type: TYPES.OPEN_NAV_SEARCH });
  };
}

export function closeNavSearch() {
  return async (dispatch) => {
    dispatch({ type: TYPES.CLOSE_NAV_SEARCH });
  };
}
